import { I18nComponente } from "@/types/gerais"

export const NovoGrupoi18n: I18nComponente = {
  "pt-BR": {
    selecionarProjetosParaAdicionarAoGrupo: "selecione projetos para adicionar ao grupo",
    salvar: "salvar",
    cancelar: "cancelar",
    projetos: "projetos",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    criarGrupoDeProjetos: "criar grupo de projetos",
    cancelarCriacaoDoGrupoDeProjetos: "cancelar criação do grupo de projetos?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Ao cancelar você perderá todas as informações não salvas",
    grupoDeProjetosCriadoComSucesso: "Grupo de projetos criado com sucesso!",
    vocePodeAcessaLoNoMenuEsquerda: "Você pode acessá-lo no menu à esquerda",
    erroAoCriarGrupoDeProjetos: "Erro ao criar o grupo de projetos",
    ocorreuUmErroAoCriarGrupoDeProjetos: "Ocorreu um erro ao criar o grupo de projetos, tente novamente mais tarde.",
    erroAoBuscarOsUsuariosResponsaveis: "Erro ao buscar os usuários responsáveis",
    ocorreuUmErroAoBuscarOsUsuariosResponsaveis: "Ocorreu um erro ao buscar os usuários responsáveis, tente novamente mais tarde.",
  },
  "es-CO": {
    selecionarProjetosParaAdicionarAoGrupo: "seleccione proyectos para añadir al grupo",
    salvar: "guardar",
    cancelar: "cancelar",
    projetos: "proyectos",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    criarGrupoDeProjetos: "añadir grupo de proyectos",
    cancelarCriacaoDoGrupoDeProjetos: "¿cancelar creación del grupo de proyectos?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Al cancelar perderás toda la información no guardada",
    grupoDeProjetosCriadoComSucesso: "Grupo de proyectos creado con éxito!",
    vocePodeAcessaLoNoMenuEsquerda: "Puede accederlo en el menú de la izquierda",
    erroAoCriarGrupoDeProjetos: "Error al añadir el grupo de proyectos",
    ocorreuUmErroAoCriarGrupoDeProjetos: "Ocurrió un error al añadir el grupo de proyectos, inténtelo de nuevo más tarde.",
    erroAoBuscarOsUsuariosResponsaveis: "Error al buscar los usuarios responsables",
    ocorreuUmErroAoBuscarOsUsuariosResponsaveis: "Ocurrió un error al buscar los usuarios responsables, inténtelo de nuevo más tarde.",
  }
}
